import {
  BaseInfo,
  MainPresets,
  UnifiedPage,
  UnifiedLightbox,
  WidgetInstallationSettings,
  WidgetAsContent,
  WidgetSize,
  CodePackageComponentData,
  Preset,
  ComponentType,
  PageWidgetAsContent,
  RegionType,
  DefaultPresets,
  StaticContainer,
} from '@wix/ambassador-devcenter-components-v1-component/types';
import {
  CompRef,
  UnitSize,
  AppData as DocumentAppData,
  Point,
  WidgetDescriptor,
  BuilderComponent,
  PageRef,
} from '@wix/document-services-types';

type AppData = Required<DocumentAppData> & { isUnifiedComponentsApp?: boolean };

type AddToStageData = {
  position?: Point;
  presetId?: string;
  mobilePresetId?: string;
};

type UnifiedWidget = {
  base?: BaseInfo;
  installation?: WidgetInstallationSettings;
  widgetId: string;
  type: string;
  size?: WidgetSize;
  presets?: Preset[];
  [key: string]: any;
};

type Container =
  | {
      data: UnifiedPage;
      type: ComponentType.UNIFIED_PAGE;
    }
  | {
      data: UnifiedLightbox;
      type: ComponentType.UNIFIED_LIGHTBOX;
    };

type ContainerWidgetAsContent = WidgetAsContent | PageWidgetAsContent;

type UnifiedComponentsCollection = {
  pages: Record<string, Container>;
  widgets: Record<string, UnifiedWidget>;
  builderComponents: Record<string, BuilderComponent>;
  codePackages: CodePackageComponentData[];
};

type UnifiedComponentAddedToTheStageData = {
  pages: Record<string, PageRef>;
  widgets: Record<string, CompRef>;
};

type AddBlocksWidgetOptions = {
  widgetId: string;
  position?: Point;
  size?: {
    width: UnitSize;
    height: UnitSize;
  };
  presetId?: string;
  containerRef?: CompRef;
  mobilePresetId?: string;
  isStretched?: boolean;
};

type AddAppData = AppData & {
  type: string;
  success: boolean;
};

type ContainerData = Container['data'];

enum DefaultPresetKeys {
  SMALL = 'small',
  LARGE = 'large',
}

interface PresetsOptions {
  widgetDefinition: UnifiedWidget;
  presetIdKey?: keyof DefaultPresets;
  overridePreset?: MainPresets;
  shouldReadDataFromNewSchema?: boolean;
}

type WidgetAppearanceDescriptor = Pick<
  WidgetDescriptor,
  'defaultSize' | 'presets'
>;

export type {
  BaseInfo,
  MainPresets,
  UnifiedPage,
  UnifiedLightbox,
  Container,
  UnifiedWidget,
  BuilderComponent,
  UnifiedComponentsCollection,
  UnifiedComponentAddedToTheStageData,
  WidgetAsContent,
  PageWidgetAsContent,
  AddBlocksWidgetOptions,
  AppData,
  AddAppData,
  WidgetSize,
  AddToStageData,
  Preset,
  ContainerData,
  ContainerWidgetAsContent,
  DefaultPresets,
  WidgetAppearanceDescriptor,
};

export {
  ComponentType,
  RegionType,
  DefaultPresetKeys,
  StaticContainer,
  PresetsOptions,
};
